import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkModule } from '../link/link.module';
import { LabelWithLinkComponent } from './label-with-link.component';

@NgModule({
  declarations: [LabelWithLinkComponent],
  imports: [CommonModule, LinkModule],
  exports: [LabelWithLinkComponent]
})
export class LabelWithLinkModule {}
